import { signal } from '@preact/signals-react';
import { PromptDialogProps } from '~/components/dialogs/PromptDialog';

export const showPromatDialog = signal<PromptDialogProps | null>(null);

export function setWarnPromatDialog(options: {
  renderContent: PromptDialogProps['renderContent']
  onConfirm: PromptDialogProps['onConfirm']
}) {
  const props: PromptDialogProps = {
    onConfirm: options.onConfirm,
    title: 'Warn',
    renderContent: options.renderContent,
  };
  showPromatDialog.value = props;
}
